import React from "react";

const Java_Random_Number = () => {
  return (
    <div>
      <h1>Java Random Number</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Random Number in Java.</p>
    </div>
  );
};

export default Java_Random_Number;
